import ActionCardContainer from './ActionCardContainer';
import ActionCardUI from './ActionCardUI';

const ActionCard = {
    Container: ActionCardContainer,
    UI: ActionCardUI
};

export default ActionCard;
